export default __webpack_public_path__ + "static/media/435.789c8336.png";